import { RadioGroup, RadioGroupItem } from '../ui/RadioGroup'

type Permission = 'view' | 'edit'

type PermissionsSelectorProps = {
	value: Permission
	onChange: (value: Permission) => void
	disabled?: boolean
}

export function PermissionsSelector({ value, onChange, disabled }: PermissionsSelectorProps) {
	return (
		<div>
			<label className="playbook-share-label">Permission</label>
			<RadioGroup
				value={value}
				onValueChange={(v) => onChange(v as Permission)}
				disabled={disabled}
				className="playbook-share-permissions"
			>
				<label className="playbook-share-permission-option">
					<RadioGroupItem value="view" />
					<span className="playbook-share-permission-text">
						<strong>View</strong> - Can view playbook and plays
					</span>
				</label>
				<label className="playbook-share-permission-option">
					<RadioGroupItem value="edit" />
					<span className="playbook-share-permission-text">
						<strong>Edit</strong> - Can view and edit playbook and plays
					</span>
				</label>
			</RadioGroup>
		</div>
	)
}
